import { useI18n } from "i18n";
import { IUserProfile } from "modules/app/types";
import { setAuth } from "modules/auth/redux/authSlice";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import userProfileApi from "modules/userProfile/userProfile.api";
import { useMutation } from "@tanstack/react-query";
import { useAppDispatch } from "store/hooks";

const useUpdateMyProfile = () => {
  const { t } = useI18n("server");
  const { addErrorNotification } = useNotificationActions();
  const dispatch = useAppDispatch();

  const mutation = useMutation({
    mutationFn: async (data: Partial<IUserProfile>) => {
      const response = await userProfileApi.updateMyProfile(data);

      if (response.isSuccess) {
        return response.user;
      }

      throw Error(t(response.message));
    },
    onError: (error) => {
      if (error instanceof Error) {
        addErrorNotification({
          message: error.message,
          autoDismiss: 10,
        });
      }
    },
    onSuccess: (user) => {
      dispatch(setAuth(user));
    },
  });

  return mutation;
};

export default useUpdateMyProfile;
